import { useEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import { getRestaurantSelectionInfo } from "../../../const";
import Const from "../../../const/Const";
import messageConst from "../../../const/messageConst";
import { useRtoaster } from "../../../hooks/useRtoaster";
import common from "../../../resources/js/common/common";
import { BreadCrumb } from '../../molecules/breadCrumb';
import { PullDownOptionForm } from "../../molecules/pullDownOptionForm";
import { RestaurantAllList } from "../../molecules/restaurantAllList";
import { MembershipFooterContainer } from '../common/membershipFooterContainer';
import './../../../resources_membership_hotel/css/hotel/inputUser.css';

const RestaurantListContainer = (props) => {
    const {
        login,
        onClickOpenPopupWindow,
        setRestaurantInfo,
        resvKaiinken,
        setResvKaiinken,
        setRestaurantReserveInfo,
        setServiceCheckInfo,
        setKaiinkenFlg
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const [modalFlg, setModalFlg] = useState(false);
    const history = useHistory();
    const store = useStore();
    const [linkList, setLinkList] = useState([]);
    const [selectionList, setSelectionList] = useState([]);
    const [kaiinkenNumber, setKaiinkenNumber] = useState("1");

    // プロパティ一覧

    // エラー情報
    const [flgList, setFlgList] = useState(false);

    // rtoasterタグ生成
    useRtoaster();

    useEffect(() => {
        // common.doPost(versionGetApi, {}, afterVerCheck);
        setLinkList([{ path: "/reserve/top", label: "HOME" }]);
        // window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }

        // 会員制フラグ
        let req = {
            membershipFlg: true,
        }

        // レストラン選択情報取得
        // ローカル動作確認用にコメント化
        common.doPost(getRestaurantSelectionInfo, req, afterGetRestaurantSelectionInfo);

        // エラーメッセージ取得
        // common.doPost(getErrorMessage, {}, afterGetErrorMessage);

        // ローカル動作確認用
        // setSelectionList([
        //     {
        //         honkanShisetsuCd: "401",
        //         shisetsuCd: "401",
        //         shisetsuName: "東京ベイコート倶楽部",
        //         shisetsuImagePath: "/static/media/BaycourtClub/TokyoBaycourtClub.jpg",
        //         restaurantList: [
        //             {
        //                 restaurantCd: "22",
        //                 restaurantName: "RISTORANTE OZIO",
        //                 restaurantImagePath: "/static/media/OZIO_1.jpg",
        //                 restaurantSetsumei: "イタリア料理",
        //                 tenpoSetsumei: "イタリア料理がおいしいです",
        //                 tenpoSetsumeiURL: "https://OZIO.com"
        //             },
        //             {
        //                 restaurantCd: "23",
        //                 restaurantName: "RISTORANTE OZIO 2",
        //                 restaurantImagePath: "/static/media/OZIO_2.jpg",
        //                 restaurantSetsumei: "フランス料理",
        //                 tenpoSetsumei: "フランス料理がおいしいです",
        //                 tenpoSetsumeiURL: "https://OZIO.com"
        //             }
        //         ]
        //     },
        //     {
        //         honkanShisetsuCd: "402",
        //         shisetsuCd: "402",
        //         shisetsuName: "横浜ベイコート倶楽部",
        //         shisetsuImagePath: "/static/media/BaycourtClub/TokyoBaycourtClub.jpg",
        //         restaurantList: [
        //             {
        //                 restaurantCd: "42",
        //                 restaurantName: "RISTORANTE OZIO YOKOHAMA",
        //                 restaurantImagePath: "/static/media/OZIO_1.jpg",
        //                 restaurantSetsumei: "イタリア料理",
        //                 tenpoSetsumei: "イタリア料理がおいしいです",
        //                 tenpoSetsumeiURL: "https://OZIO.com"
        //             },
        //             {
        //                 restaurantCd: "43",
        //                 restaurantName: "RISTORANTE OZIO 2 YOKOHAMA",
        //                 restaurantImagePath: "/static/media/OZIO_2.jpg",
        //                 restaurantSetsumei: "フランス料理",
        //                 tenpoSetsumei: "フランス料理がおいしいです",
        //                 tenpoSetsumeiURL: "https://OZIO.com"
        //             }
        //         ]
        //     },
        // ]);

        // 会員権情報設定処理
        resvKaiinken.sort((a, b) => a.keiyakuDatSort - b.keiyakuDatSort);
        resvKaiinken.forEach((value, index) => {
            if (index === 0) {
                value.selected = true;
                setKaiinkenNumber(value.id)
            } else {
                value.selected = false;
            }
        })
        setResvKaiinken(resvKaiinken);
        setRestaurantReserveInfo({});
        setRestaurantInfo({});
        setServiceCheckInfo({});
    }, [useMediaFlag]);

    // レストラン選択情報取得
    const afterGetRestaurantSelectionInfo = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            const shisetsuList = data.shisetsuList;
            let messageFlg = true;
            shisetsuList.filter(shisetsu => {
                let generalRestaurant = shisetsu.restaurantList.filter(restaurant => !restaurant.membershipFlg);
                if (generalRestaurant.length) {
                    messageFlg = false;
                }
            });
            if (messageFlg) {
                if (resvKaiinken.length > 1) {
                    messageFlg = false;
                } else if (resvKaiinken.length == 1 && resvKaiinken[0].keiyakuNo != Const.GENERAL_CONTRACT_NO) {
                    messageFlg = false;
                } else {
                    const memberInfo = login?.memberInfo;
                    if (memberInfo) {
                        memberInfo.forEach(member => {
                            member?.memberList?.data?.kaiinInfoList?.forEach(kaiinInfo => {
                                if (kaiinInfo?.bccKeiyakuKbn != 1 && kaiinInfo?.kaihiMinoKbn != 1) {
                                    messageFlg = false;
                                    return;
                                }
                            })
                            if (!messageFlg) {
                                return;
                            }
                        });
                    } 
                }
            }
            setKaiinkenFlg(messageFlg);
            // let shisetsuFlg = false;
            // resvKaiinken.forEach((data) => {
            //     const targetShisetu = shisetsuList.filter(shisetsu => {
            //         let result = false;
            //         let generalRestaurant = shisetsu.restaurantList.filter(restaurant => !restaurant.membershipFlg);
            //         if (generalRestaurant.length || shisetsu.shisetsuCd == data.sisetuCd) {
            //             result = true;
            //         }
            //         return result;
            //     });
            //     if (targetShisetu.length) {
            //         shisetsuFlg = true;
            //         return;
            //     }
            // })
            // setKaiinkenFlg(!shisetsuFlg);
            setSelectionList(shisetsuList);
        }
    }

    // 「戻る」ボタン押下時
    const onClickBack = () => {
        history.push("/reserve/rtcc/reservationResult");
    }

    const onChangeKaiinkenName = (e) => {
        const kaiinkenRef = e.target.value;
        resvKaiinken.forEach((data) => {
            if (String(data.id) === kaiinkenRef) {
                data.selected = true;
                setKaiinkenNumber(data.id)
            } else {
                data.selected = false;
            }
        })
        setResvKaiinken(resvKaiinken);
    }

    // レストラン画像エラー時処理
    const handleErrorImage = (shisetsuCd, restaurantCd) => {
        let newSelectionList = [];
        selectionList.forEach(facility => {
            if (facility.shisetsuCd == shisetsuCd) {
                let newRestaurantList = [];
                if (facility.restaurantList && restaurantCd) {
                    facility.restaurantList.forEach((restaurant) => {
                        if (restaurant.restaurantCd != restaurantCd) {
                            newRestaurantList.push(restaurant);
                        }
                    });
                }
                facility.restaurantList = newRestaurantList;
            }
            if (facility.restaurantList?.length > 0) {
                newSelectionList.push(facility);
            }
        });
        setSelectionList(newSelectionList);
    }

    // プラン詳細ポップアップ
    const handlePlanDetail = (facilityId, planId) => {
        setModalFlg(true);
    }

    // 「予約する」ボタン押下
    const handleReserve = (shisetsuIndex, restaurantIndex) => {
        const memberInfo = login?.memberInfo;
        const shisetsuInfo = selectionList[shisetsuIndex];
        const restaurantInfo = shisetsuInfo.restaurantList[restaurantIndex];
        let keiyakuNo = "";
        let riyoKaiinkenSyubetCd = "";
        let shisetsuFlg = false;
        resvKaiinken.forEach((data) => {
            if (data.selected) {
                keiyakuNo = data.keiyakuNo;
                riyoKaiinkenSyubetCd = data.riyoKaiinkenSyubetCd;
                if (!restaurantInfo.membershipFlg) {
                // if (!restaurantInfo.membershipFlg || (data.sisetuCd == selectionList[shisetsuIndex].shisetsuCd)) {
                    shisetsuFlg = true;
                }
                return;
            }
        })
        let messageFlg = true;
        if (memberInfo) {
            memberInfo.forEach(member => {
                member?.memberList?.data?.kaiinInfoList?.forEach(kaiinInfo => {
                    if (kaiinInfo?.bccKeiyakuKbn != 1 && kaiinInfo?.kaihiMinoKbn != 1) {
                        if (keiyakuNo == Const.GENERAL_CONTRACT_NO) {
                            keiyakuNo = kaiinInfo.keiyakuNo
                        }
                        messageFlg = false;
                        return;
                    }
                })
                if (!messageFlg) {
                    return;
                }
            });
        } else if (shisetsuFlg) {
            messageFlg = false;
        } 
        // setKaiinkenFlg(messageFlg || !shisetsuFlg);
        setKaiinkenFlg(messageFlg);
        // if (!messageFlg && shisetsuFlg) {
        if (!messageFlg) {
            setRestaurantInfo({
                // 詰めたい値
                honkanShisetsuCd: shisetsuInfo.honkanShisetsuCd,
                shisetsuCd: shisetsuInfo.shisetsuCd,
                shisetsuName: shisetsuInfo.shisetsuName,
                restaurantCd: restaurantInfo.restaurantCd,
                restaurantName: restaurantInfo.restaurantName,
                keiyakuNo: keiyakuNo,
                riyoKaiinkenSyubetCd: riyoKaiinkenSyubetCd,
                memberCd: resvKaiinken[0].memberCd,
            })
            history.push("/reserve/hotel/restaurantReserve");
        }
    }

    return (
        <div>
            <div className="restaurantListInnerWrapper">
                <BreadCrumb
                    breadCrumbStyle={isWideTablet ? { display: "none" } : styles.breadCrumb}
                    linkStyle={styles.link}
                    linkList={linkList}
                    lastLabel="レストラン予約"
                    lastLabelClassName="lastLabel"
                />
                {login.memberCode && resvKaiinken?.length > 1 ?
                    <PullDownOptionForm
                        id="kaiinken"
                        divClass={isMobilePhone ? "kaiinkenWrapMobile" : "wrap"}
                        title={"会員権選択"}
                        selectClass="pullDownOptionKaiinkenStyle"
                        labelClassName="modalLabel"
                        data={resvKaiinken}
                        state={kaiinkenNumber}
                        onChange={onChangeKaiinkenName} />
                    : null}
                {/* レストラン一覧 */}
                <RestaurantAllList
                    flgList={flgList}
                    responsiveFlg={isWideTablet}
                    onClickOpenPopupWindow={onClickOpenPopupWindow}
                    handlePlanDetail={handlePlanDetail}
                    handleErrorImage={handleErrorImage}
                    handleReserve={handleReserve}
                    selectionList={selectionList}
                    loginFlg={!!login.memberCode}
                />
            </div>
            <div style={styles.footer}>
                <MembershipFooterContainer footerClass={"reservationResultFooterBase"} />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        login: state.login,
        restaurantInfo: state.restaurantInfo,
        resvKaiinken: state.resvKaiinken,
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setRestaurantInfo: (item) => {
            dispatch({ type: "RESTAURANT_INFO", payload: { restaurantInfo: item } })
        },
        setRestaurantReserveInfo: (item) => {
            dispatch({ type: "RESTAURANT_RESERVE_INFO", payload: { restaurantReserveInfo: item } })
        },
        setResvKaiinken: (item) => {
            dispatch({ type: "RESV_KAIINKEN", payload: { resvKaiinken: item } })
        },
        setServiceCheckInfo: (item) => {
            dispatch({ type: "SERVICE_CHECK_INFO", payload: { serviceCheckInfo: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(RestaurantListContainer);

const styles = {
    breadCrumb: {
        display: "flex",
        color: "gray",
        padding: "8px 0px 30px 0px",
    },
    breadCrumb2: {
        marginBottom: "30px",
    },
    userInput: {
        display: "block",
        flexWrap: "wrap",
    },
    link: {
        display: "inline-block",
        padding: "3px",
        color: "gray",
        fontSize: "small",
    },
    bottomLink: {
        padding: "3px",
        color: "#696969",
        fontSize: "small",
    },
    errorMassage: {
        display: "inline-block",
        textAlign: "left",
        padding: "15px 0px 0px 0px",
    },
    errorDiv: {
        display: "block",
        color: "red",
        textAlign: "center",
        fontSize: "0.8rem",
        background: "rgba(255,255,255,0)",
        border: 0,
        fontWeight: "bold"
    },
}
